let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2nTkk")).then(() => parcelRequire('dGCxL'));